(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.yw-reference [data-rail-section]').forEach(section => {
    const rail = section.querySelector('[data-rail]');
    const prev = section.querySelector('[data-rail-prev]');
    const next = section.querySelector('[data-rail-next]');
    if (!rail || !prev || !next) return;
    const update = () => {
      prev.disabled = rail.scrollLeft < 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const move = direction => {
      const step = (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth) + (parseFloat(getComputedStyle(rail).gap) || 0);
      rail.scrollBy({left: step * direction, behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true});
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
    new ResizeObserver(update).observe(rail);
    update();
  });
  const links = [...document.querySelectorAll('.yw-reference .help-nav a')];
  if (links.length) {
    const update = () => {
      let current = links[0];
      for (const link of links) {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) continue;
        // Match the anchor's responsive landing position, allowing scroll rounding.
        const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        if (target.getBoundingClientRect().top <= offset + 1) current = link;
      }
      links.forEach(link => link === current ? link.setAttribute('aria-current','location') : link.removeAttribute('aria-current'));
    };
    let queued = false;
    const scheduleUpdate = () => {
      if (queued) return;
      queued = true; requestAnimationFrame(() => {update(); queued = false;});
    };
    window.addEventListener('scroll', scheduleUpdate, {passive:true});
    window.addEventListener('resize', scheduleUpdate);
    update();
  }
  const cm = document.getElementById('cm'), inches = document.getElementById('inches');
  const convert = () => {
    const value = Number(cm.value);
    inches.textContent = cm.value !== '' && Number.isFinite(value) && value >= 0 && value <= 10000 ? (value / 2.54).toFixed(2) + '″' : '—';
  };
  cm?.addEventListener('input', convert);
  document.getElementById('converter')?.addEventListener('submit', event => {event.preventDefault();convert();});
  const dialog = document.getElementById('authorization-dialog');
  const open = document.getElementById('open-authorization');
  if (dialog && open) {
    open.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-close-dialog]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => open.focus({preventScroll:true}));
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
  }
  // Delegate to the current header so Shopify section replacement needs no rebinding.
  if (window.yeswoodNavigationInitialized) return;
  window.yeswoodNavigationInitialized = true;
  const navigation = () => {
    const toggle = document.querySelector('.yw-menu-toggle');
    const nav = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    return toggle && nav ? {toggle, nav} : null;
  };
  const setOpen = (menu, expanded, returnFocus = false) => {
    const {toggle, nav} = menu;
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute('aria-label', expanded ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    toggle.closest('.section-header')?.classList.toggle('menu-open', expanded);
    if (!expanded) {
      nav.querySelectorAll('localization-form').forEach(form => form.hidePanel?.());
      if (returnFocus) toggle.focus({preventScroll: true});
    }
  };
  document.addEventListener('click', event => {
    const menu = navigation();
    if (!menu) return;
    if (menu.toggle.contains(event.target)) {
      setOpen(menu, menu.toggle.getAttribute('aria-expanded') !== 'true');
    } else if (!menu.nav.contains(event.target) ||
               (event.target.closest('a') && !event.target.closest('localization-form'))) {
      setOpen(menu, false, menu.nav.contains(document.activeElement));
    }
  });
  // Localization handles its own Escape first and stops propagation at the inner panel.
  document.addEventListener('keyup', event => {
    const menu = navigation();
    if (menu && event.key === 'Escape' && menu.toggle.getAttribute('aria-expanded') === 'true') {
      setOpen(menu, false, true);
    }
  });
  document.addEventListener('focusin', event => {
    const menu = navigation();
    if (menu && !menu.nav.contains(event.target) && !menu.toggle.contains(event.target)) setOpen(menu, false);
  });
  document.addEventListener('shopify:section:unload', event => {
    const menu = navigation();
    if (menu && event.target.contains(menu.toggle)) setOpen(menu, false);
  });
  matchMedia('(max-width: 989px)').addEventListener('change', event => {
    const menu = navigation();
    if (!menu) return;
    const header = menu.toggle.closest('.section-header');
    const active = document.activeElement;
    const focusInSelector = header?.contains(active) && active.closest('localization-form');
    const focusInMenu = menu.nav.contains(active);
    setOpen(menu, false);
    header?.querySelectorAll('localization-form').forEach(form => form.hidePanel?.());
    if (event.matches && (focusInMenu || focusInSelector)) menu.toggle.focus({preventScroll: true});
    if (!event.matches && focusInMenu && focusInSelector) menu.nav.querySelector('a')?.focus({preventScroll: true});
  });
})();
(() => {
  const players = document.querySelectorAll('.yw-reference [data-community-player]');
  if (!players.length) return;
  // TikTok throttles a visitor who opens several players at once (errorCode 2005, TOO_MANY_REQUESTS),
  // so players load one at a time, spaced out, and a throttled player waits and retries.
  const GAP = 1200, BACKGROUND_GAP = 2500, LOAD_TIMEOUT = 10000, BACKOFF = [4000, 10000, 25000];
  const queue = [];
  let busy = false, lastStart = 0, holdUntil = 0, timer = 0;
  const state = new WeakMap();
  const info = media => state.get(media) || state.set(media, {tries: 0}).get(media);
  const pump = () => {
    clearTimeout(timer);
    if (busy || !queue.length) return;
    const wait = Math.max(holdUntil, lastStart + (queue[0].background ? BACKGROUND_GAP : GAP)) - Date.now();
    if (wait > 0) { timer = setTimeout(pump, wait); return; }
    const {media, autoplay} = queue.shift();
    busy = true; lastStart = Date.now();
    const frame = document.createElement('iframe');
    frame.src = `https://www.tiktok.com/player/v1/${encodeURIComponent(media.dataset.communityPlayer)}?autoplay=${autoplay ? 1 : 0}&music_info=0&description=0&rel=0&native_context_menu=0`;
    frame.title = media.dataset.playerTitle || 'TikTok';
    frame.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    const done = () => { if (!busy) return; busy = false; clearTimeout(guard); pump(); };
    const guard = setTimeout(done, LOAD_TIMEOUT);
    frame.addEventListener('load', done, {once: true});
    media.classList.remove('is-waiting');
    media.replaceChildren(frame);
  };
  const enqueue = (media, {autoplay = false, background = false} = {}) => {
    if (media.querySelector('iframe')) return;
    const queued = queue.findIndex(item => item.media === media);
    if (queued >= 0) {
      if (background || !queue[queued].background) return;
      queue.splice(queued, 1);
    }
    media.classList.add('is-waiting');
    if (background) queue.push({media, autoplay, background});
    else {
      const firstBackground = queue.findIndex(item => item.background);
      queue.splice(firstBackground < 0 ? queue.length : firstBackground, 0, {media, autoplay, background});
    }
    pump();
  };
  // After the last retry, offer a manual reload next to the TikTok link.
  const fallback = media => {
    const box = document.createElement('div');
    box.className = 'community-placeholder community-fallback';
    const retry = document.createElement('button');
    retry.type = 'button'; retry.textContent = media.dataset.retryLabel;
    retry.addEventListener('click', () => { info(media).tries = 0; enqueue(media, {autoplay: true}); });
    const link = document.createElement('a');
    link.href = media.dataset.videoUrl; link.target = '_blank'; link.rel = 'noopener';
    link.textContent = media.dataset.fallbackLabel;
    box.append(retry, link);
    media.replaceChildren(box);
  };
  const fail = (media, throttled) => {
    const item = info(media);
    const limit = throttled ? BACKOFF.length : 1;
    if (item.tries >= limit) { fallback(media); return; }
    const delay = BACKOFF[item.tries++];
    // Throttling is per visitor, so hold the whole queue, not just this player.
    if (throttled) holdUntil = Math.max(holdUntil, Date.now() + delay);
    media.replaceChildren();
    setTimeout(() => enqueue(media), delay);
  };
  // Cards without a cover load when scrolled into view, and keep the next few ready ahead of the
  // visitor; covered cards wait for a click.
  const uncovered = [...players].filter(media => !media.querySelector('[data-community-play]'));
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target); enqueue(entry.target);
      const next = uncovered.indexOf(entry.target) + 1;
      uncovered.slice(next, next + 3).forEach(media => enqueue(media, {background: true}));
    });
  }, {rootMargin: '100px'}) : null;
  players.forEach(media => {
    const poster = media.querySelector('[data-community-play]');
    if (poster) poster.addEventListener('click', () => { enqueue(media, {autoplay: true}); loadRest(); });
    else if (observer) observer.observe(media);
    else enqueue(media);
  });
  // Once the page has loaded, get the first few ready. The rest wait until a visitor actually
  // plays a video, since each player is a full page from TikTok.
  const INITIAL_PRELOAD = 4;
  const preload = () => {
    if (navigator.connection?.saveData) return;
    uncovered.slice(0, INITIAL_PRELOAD).forEach(media => enqueue(media, {background: true}));
  };
  let restLoaded = false;
  const loadRest = () => {
    if (restLoaded || navigator.connection?.saveData) return;
    restLoaded = true;
    uncovered.forEach(media => enqueue(media, {background: true}));
  };
  const schedulePreload = () => setTimeout(() => (window.requestIdleCallback || (run => run()))(preload), 1000);
  if (document.readyState === 'complete') schedulePreload();
  else window.addEventListener('load', schedulePreload, {once: true});
  window.addEventListener('message', event => {
    if (event.origin !== 'https://www.tiktok.com') return;
    let data = event.data;
    if (typeof data === 'string') { try { data = JSON.parse(data); } catch (error) { return; } }
    if (!data || !data['x-tiktok-player']) return;
    const frames = [...document.querySelectorAll('.yw-reference [data-community-player] iframe')];
    const source = frames.find(frame => frame.contentWindow === event.source);
    if (data.type === 'onPlayerError') {
      if (source) fail(source.closest('[data-community-player]'), data.value?.errorCode === 2005);
      return;
    }
    // Keep one video playing at a time.
    if (data.type !== 'onStateChange' || data.value !== 1) return;
    loadRest();
    frames.forEach(frame => {
      if (frame !== source) frame.contentWindow.postMessage({type: 'pause', value: null, 'x-tiktok-player': true}, '*');
    });
  });
})();
(() => {
  const dialog = document.querySelector('.yw-reference [data-community-dialog]');
  const open = document.querySelector('.yw-reference [data-community-submit]');
  if (!dialog || !open || typeof dialog.showModal !== 'function') return;
  open.addEventListener('click', () => dialog.showModal());
  // After submitting, the page reloads with the result, so show it again.
  if (dialog.querySelector('[data-community-submit-status]')) dialog.showModal();
})();
